import { IconSlash, IconCheckCircle } from '../../ui'
import React from 'react'


type ICheckBoxStatusIcon<T> = {
	value: boolean | null
	iconCheckColor?: string
	rowData?: T
	onClick?: (rowData: T, e: React.MouseEvent) => void;
}

export function CheckBoxStatusIcon<T>({
	value,
	iconCheckColor,
	rowData,
	onClick
}: ICheckBoxStatusIcon<T>) {
	const iconCheckDefaultColor = '--successColor'
	let icon

	switch (value) {
		case true: {
			icon = <i onClick={
				(e) => onClick && rowData !== undefined && onClick(rowData, e)}
			>
				<IconCheckCircle size={20}
				                 stroke={`var(${iconCheckColor ?? iconCheckDefaultColor}, black)`}
				/>
			</i>
			break
		}
		case false: {
			icon = <i onClick={
				(e) => onClick && rowData !== undefined && onClick(rowData, e)}
			>
				<IconSlash size={20}/>
			</i>
			break
		}
		default: {
			icon = null
			break
		}
	}

	return icon
}